import { supabase } from '../supabase';

const BUCKET = 'empresa-assets';

/**
 * Upload a customer payment proof. Path matches RLS
 * `empresa_assets_authenticated_insert`: facturas/{empresaId}/comprobantes/{ownerId}/...
 */
export async function uploadPagoComprobante(params: {
  empresaId: string;
  ownerId: string;
  file: File;
}): Promise<{ url: string | null; path: string | null; error: string | null }> {
  const { empresaId, ownerId, file } = params;
  if (!empresaId || !ownerId || !file) {
    return { url: null, path: null, error: 'Faltan datos para subir el comprobante.' };
  }
  const ext = (file.name.split('.').pop() || 'jpg').replace(/[^a-zA-Z0-9]/g, '').slice(0, 8) || 'jpg';
  const path = `facturas/${empresaId}/comprobantes/${ownerId}/${Date.now()}.${ext}`;
  const { data: up, error: upErr } = await supabase.storage.from(BUCKET).upload(path, file, {
    cacheControl: '3600',
    upsert: false,
    contentType: file.type || undefined,
  });
  if (upErr) {
    return { url: null, path: null, error: upErr.message };
  }
  const storedPath = up?.path || path;
  const { data: pub } = supabase.storage.from(BUCKET).getPublicUrl(storedPath);
  return { url: pub?.publicUrl ?? null, path: storedPath, error: null };
}

export async function patchPagoAdjuntos(
  tabla: 'pagos_cobro' | 'pagos_credito' | 'pagos_factura',
  pagoId: string,
  patch: {
    comprobante_url?: string | null;
    comprobante_path?: string | null;
    recibo_url?: string | null;
  }
): Promise<void> {
  if (!pagoId || Object.keys(patch).length === 0) return;
  const { error } = await supabase.from(tabla).update(patch).eq('id', pagoId);
  if (error) {
    console.warn(`[patchPagoAdjuntos] ${tabla}:`, error.message);
  }
}
